import { DataContext } from '../../data/DataContext';
import { useContext, useEffect, useState } from 'react';
import { DropDown, Input, ModalControl } from '../controls';
import http from '../../../../services/http';
import { endPoints } from '../../../../utils/constanst';
import { propLoading } from '../../data/Help';

const Step2 = () => {
    const { IH_CR, setIH_CR, changeHandler } = useContext(DataContext);
    const [lstProvince, setLstProvince] = useState([]);
    const [lstCanton, setLstCanton] = useState([]);
    const [lstDistrict, setlstDistrict] = useState([]);
    const [lstNeighborhood, setLstNeighborhood] = useState([]);
    const [propModal, setPropModal] = useState({} as IModalProps);



    useEffect(() => {
        GetProvince();
    }, []);

    useEffect(() => {
        GetCanton();
    }, [IH_CR.province]);

    useEffect(() => {
        GetDistrict();
    }, [IH_CR.canton]);

    useEffect(() => {
        GetNeighborhood();
    }, [IH_CR.district]);


    const onChangeCbo = (property: string, value: string) => {
        setIH_CR({ ...IH_CR, [property]: value });
    }

    const GetProvince = () => {
        setPropModal({ ...propModal, active: true });
        http(endPoints.department(`506`)).get().then((result) => {
            setLstProvince(result);
        }).catch(

        ).finally(() => {
            setPropModal({ ...propModal, active: false });
        });
    }

    const GetCanton = () => {
        setPropModal({ ...propModal, active: true });
        setPropModal({ ...propModal, ...propLoading });
        if (IH_CR.province != '') {
            http(endPoints.country(`506`, IH_CR.province)).get().then((result) => {
                setLstCanton(result);
            }).catch(

            ).finally(() => {
                setPropModal({ ...propModal, active: false });
            });
        }
    }

    const GetDistrict = () => {
        setIH_CR({ ...IH_CR, district: '' });
        setPropModal({ ...propModal, active: true });
        if (IH_CR.canton != '') {
            http(endPoints.district(`506`, IH_CR.province, IH_CR.canton)).get().then((result) => {
                setlstDistrict(result);
            }).catch(

            ).finally(() => {
                setPropModal({ ...propModal, active: false });
            });
        }
    }

    const GetNeighborhood = () => {
        setIH_CR({ ...IH_CR, neighborhood: '' });
        setPropModal({ ...propModal, active: true });
        if (IH_CR.district != '') {
            http(endPoints.neighborhood(`506`, IH_CR.province, IH_CR.canton, IH_CR.district)).get().then((result) => {
                setLstNeighborhood(result);
            }).catch(

            ).finally(() => {
                setPropModal({ ...propModal, active: false });
            });
        }
    }

    return (
        <>
            <DropDown
                label='Provincia*'
                dataProvider={lstProvince}
                valueSelect={IH_CR.province}
                field='province'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona una provincia'
            />
            <DropDown
                label='Cantón*'
                dataProvider={lstCanton}
                valueSelect={IH_CR.canton}
                field='canton'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona un cantón'
            />
            <DropDown
                label='Distrito*'
                dataProvider={lstDistrict}
                valueSelect={IH_CR.district}
                field='district'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona un Distrito'
            />
            <DropDown
                label='Barrio*'
                dataProvider={lstNeighborhood}
                valueSelect={IH_CR.neighborhood}
                field='neighborhood'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona un barrio'
            />
            <Input
                id='address'
                label='Dirección del riesgo*'
                value={IH_CR.address}
                field='address'
                onChange={changeHandler}
                placeholder="Escriba la dirección"
                type='textarea'
            />
            <Input
                id='lastName1'
                label='Año de construcción*'
                value={IH_CR.yearConstruction}
                field='yearConstruction'
                onChange={changeHandler}
                placeholder="Ej: 1990"
            />
            <ModalControl
                active={propModal.active}
                txtMsg={propModal.txtMsg}
            />
        </>
    );
}

export { Step2 };